import { useCallback, useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'redux/toolkit/hooks'
import { saveDeploymentMethod } from 'redux/features/emailServer/emailServerSlice'
import { INLINE_DEPLOYMENT_STATUSES } from 'types/emailServer'
import { trackEventInAllServices, TRACKING_EVENTS } from 'lib/monitoring/monitoringService'
import { DeploymentSetupOptions, SetupFlowCommonSteps, SetupFlowEgdSteps } from '../../../types/egdWizardTypes'

export interface State {
  error: boolean
}
export interface EventHandlers {
  onErrorClick: () => void
}

export type InlineEmailFlowLogic = [State, EventHandlers]

export const useInlineEmailFlowLogic = (): InlineEmailFlowLogic => {
  const dispatch = useAppDispatch()

  const { inlineDeploymentError, inlineDeploymentStatus } = useAppSelector(_store => ({
    inlineDeploymentError: _store.emailServer.inlineDeploymentError,
    inlineDeploymentStatus: _store.emailServer.inlineDeploymentStatus
  }))

  useEffect(() => {
    trackEventInAllServices(TRACKING_EVENTS.SETUP_FLOW.STEP_5_START_INLINE)
    // eslint-disable-next-line
  }, [])

  const onErrorClick = useCallback(() => {
    trackEventInAllServices(TRACKING_EVENTS.SETUP_FLOW.STEP_5_CHANGE_TO_MX)
    dispatch(
      saveDeploymentMethod({ step: SetupFlowEgdSteps.emailFlow, deploymentMethod: DeploymentSetupOptions.mxRecord })
    )
  }, [dispatch])

  return useMemo(
    () => [
      {
        error: inlineDeploymentError || inlineDeploymentStatus === INLINE_DEPLOYMENT_STATUSES.FAILED
      },
      {
        onErrorClick
      }
    ],
    [inlineDeploymentError, inlineDeploymentStatus, onErrorClick]
  )
}
